export const getAverage = (arr: number[]) =>
  Math.floor(arr.reduce((a, b) => a + b, 0) / arr.filter((x) => x > 0).length);
